var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Laag_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 11 11",
    style: {
      enableBackground: "new 0 0 11 11"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M5.5,10.6953125c-2.8652344,0-5.1953125-2.3300781-5.1953125-5.1953125S2.6347656,0.3046875,5.5,0.3046875 S10.6953125,2.6347656,10.6953125,5.5S8.3652344,10.6953125,5.5,10.6953125z M5.5,1.5039062 c-2.203125,0-3.9960938,1.7929688-3.9960938,3.9960938S3.296875,9.4960938,5.5,9.4960938S9.4960938,7.703125,9.4960938,5.5 S7.703125,1.5039062,5.5,1.5039062z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M6.8271484,6.0996094H5.5c-0.3310547,0-0.5996094-0.2685547-0.5996094-0.5996094V3.1308594 C4.9003906,2.7998047,5.1689453,2.53125,5.5,2.53125s0.5996094,0.2685547,0.5996094,0.5996094v1.7695312h0.7275391 c0.3310547,0,0.5996094,0.2685547,0.5996094,0.5996094S7.1582031,6.0996094,6.8271484,6.0996094z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/Clock.871846ab7da4244e28b4bea539fb6f68.svg";
export { ForwardRef as ReactComponent };